export default __webpack_public_path__ + "static/feature-banner-vietnam-ba476e6176630f1d4f083ad68b6f1d47.jpg";